<template>
    <form id="charge-monthly-credit"
          class="bg-white p-3 rounded">
        <div style="text-align: start">
            <label for="gateway_cards" style="font-size:medium">
                {{ $t('card_to_card.charge_gateway_credit') }}

                <hr>
            </label>
        </div>
        <kt-form-section is_first style="margin-top: 30px;margin-bottom: 30px">
            <kt-row>
                <kt-col lg="3" md="4" sm="6" xs="8" style="display: inline-flex;font-size: medium">
                    {{ $t('card_to_card.pay_amount') }} : <p style="color: #0be881">
                    &nbsp;{{ moneyFormat(form_data.monthly_credit_price) }} </p> &nbsp;ریال

                </kt-col>
                <kt-col style="display: inline-flex;font-size: medium">
                    <kt-button
                        class="btn-wide"
                        size="md"
                        variant="success"
                        type="button"
                        @click="submit"
                        v-bind:wide="true"
                        id="recharge_btn"
                    >
                        {{ $t('btn.pay') }}
                    </kt-button>
                </kt-col>
            </kt-row>
        </kt-form-section>
    </form>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {mapGetters} from "vuex";
import {KTApp} from '@/plugins/core/app'
import {cardToCardService} from "@/common/api.service";
import {BASE_PATH} from "@/common/config";

export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters("cardToCard", ["form_data"]),
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        submit() {
            let form = $('#charge-monthly-credit');
            let btn = $('#recharge_btn');

            KTApp.progress(btn);
            cardToCardService.rechargeGatewayCredit(this.form_data.id).then(response => {
                let tracking_code = response.data.data.tracking_code
                window.location = BASE_PATH + '/card-to-card/credit/pay-recharge/' + tracking_code;
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
                for (let err in response.data.data) {
                    this.showMsg(form, 'danger', response.data.data[err][0]);
                }
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        moneyFormat(price) {
            if (!price) return 0;
            const pieces = parseFloat(price).toFixed(0).split("");
            let ii = pieces.length;
            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ",");
            }
            return pieces.join("");
        },
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.preview_picture {
    width: 50%;
    height: 150px;
}

.remove_picture {
    cursor: pointer;
    position: absolute;
    top: -5px;
}
</style>